import { render } from "./PoolsV2.htm?vue&type=template&id=c2d16214&scoped=true"
import script from "./PoolsV2.js?vue&type=script&lang=js"
export * from "./PoolsV2.js?vue&type=script&lang=js"

import "./PoolsV2.scss?vue&type=style&index=0&id=c2d16214&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2d16214"]])

export default __exports__